import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AurFeedbackIntent, AurToastConfig, AurToastVariant } from '@shared/models/core-component.models';
import { AurIconComponent } from '../aur-icon/aur-icon.component';
import { AurButtonComponent } from '../aur-button/aur-button.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aur-toast',
  standalone: true,
  imports: [AurIconComponent, AurButtonComponent],
  template: `
    <div [class]="classes" role="status">
      <aur-icon [name]="icon" class="toast__icon" />
      <div class="toast__text">
        <span class="toast__title">{{ title }}</span>
        @if (description) {
          <span class="toast__description">{{ description }}</span>
        }
      </div>
      @if (actionLabel) {
        <aur-button [label]="actionLabel" intent="neutral" variant="ghost" [size]="32" (clicked)="action.emit()" />
      }
      @if (dismissible) {
        <aur-button
          intent="neutral"
          variant="ghost"
          [size]="32"
          [iconOnly]="true"
          leftIcon="x-outline"
          ariaLabel="Dismiss"
          class="toast__close"
          (clicked)="dismissed.emit()"
        />
      }
    </div>
  `,
})
export class AurToastComponent {
  @Input() title = '';
  @Input() description?: string;
  @Input() intent: AurFeedbackIntent = 'neutral';
  @Input() variant: AurToastVariant = 'raised';
  @Input() dismissible = true;
  @Input() actionLabel?: string;
  @Input() icon = 'circle-solid';
  @Input() set config(value: AurToastConfig | null | undefined) {
    if (!value) return;
    Object.assign(this, {
      title: value.title ?? this.title,
      description: value.description ?? this.description,
      intent: value.intent ?? this.intent,
      variant: value.variant ?? this.variant,
      dismissible: value.dismissible ?? this.dismissible,
      actionLabel: value.actionLabel ?? this.actionLabel,
      icon: value.icon ?? this.icon,
    });
  }
  @Output() dismissed = new EventEmitter<void>();
  @Output() action = new EventEmitter<void>();

  get classes(): string {
    const parts = ['toast', `toast--${this.intent}`];
    if (this.variant !== 'raised') parts.push(`toast--${this.variant}`);
    return parts.join(' ');
  }
}
